import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'ecp-rich-text-to-page',
  templateUrl: './rich-text-to-page.component.html',
  styleUrls: ['./rich-text-to-page.component.css']
})
export class RichTextToPageComponent implements OnInit {
    @Input() ecpStyle: object = {};
    @Input() page_source: String;
    @Output() outPutData = new EventEmitter<any>();
    formData;
    divObj: string;


    loadPage() {
        this.el.nativeElement.querySelector('.div').innerHTML = this.page_source;
    }

    savePage() {
        this.divObj = this.el.nativeElement.querySelector('.form');
        this.formData = this.serializeAry(this.divObj);
        this.outPutData.emit(JSON.stringify(this.formData));
        // console.log(JSON.parse(this.formData));
    }


    serializeAry(obj) {
        let res = [];   // å­æ¾ç»æçæ°ç»
        let current = null; // å½åå¾ªç¯åçè¡¨åæ§ä»¶
        let i; // è¡¨åNodeListçç´¢å¼
        let len; // è¡¨åNodeListçé¿åº¦

        const form = obj; // ç¨formåéæ¿å°å½åçè¡¨åï¼æäºè¾¨è¯

        for (i = 0, len = form.elements.length; i < len; i++) {

            current = form.elements[i];

            // disabledè¡¨ç¤ºå­æ®µç¦ç¨ï¼éè¦åºåä¸readonlyçåºå«
            if (current.disabled) continue;

            switch (current.type) {
                // å¯å¿½ç¥æ§ä»¶å¤ç
                case 'file':    // æä»¶è¾å¥ç±»å
                case 'submit':  // æäº¤æé®
                case 'button':  // ä¸è¬æé®
                case 'image':   // å¾åå½¢å¼çæäº¤æé®
                case 'reset':   // éç½®æé®
                case undefined: // æªå®ä¹
                    break;

                // selectæ§ä»¶
                case 'select-one':
                case 'select-multiple':
                    // è·åéä¸­selectå¼
                    const index = current.selectedIndex; // éä¸­ç´¢å¼
                    const text = current.options[index].text; // éä¸­ææ¬
                    const value = current.options[index].value; // éä¸­å¼
                    res.push({'name': current.name, 'value': value, 'text': text});

                    break;

                // åéï¼å¤éæ¡
                case 'radio':
                case 'checkbox':
                    // è¿éæä¸ªåå·§ çåæ³ï¼è¿éçå¤æ­æ¯è·ä¸é¢çdefaultç¸äºå¯¹åºã
                    // å¦ææ¾å¨å¶ä»å°æ¹ï¼åéè¦é¢å¤çå¤æ­åå¼
                    if (!current.checked) break;

                default:
                    // ä¸è¬è¡¨åæ§ä»¶å¤ç
                    console.log('requird', current.requird);
                    let requiems = false;
                    if (current.required && current.type === 'text') {
                        requiems = true;
                    }
                    if (current.type === 'text') {
                        res.push({
                            'id': current.id,
                            'name': current.name,
                            'value': current.value,
                            'placeholder': current.placeholder,
                            'required': requiems,
                            'type': current.type,
                        });
                    } else {
                        res.push({
                            'id': current.id,
                            'name': current.name,
                            'value': current.value,
                            'placeholder': current.placeholder,
                            'type': current.type,
                        });
                    }
                    break;
            }
        }
        //console.log(res);
        return res;

    }

    constructor(private el: ElementRef) {
    }

    ngOnInit() {
    }

    ngOnChanges() {
        // è¡¨åæ¹åæ¶æ´æ°
        // console.log('ngAfterContentChecked');
        this.loadPage();
    }

}
